import favoriteStore from '../../store/store';
import markSearchFolderAsPopulated from '../../actions/v2/people/markSearchFolderAsPopulated';
import { mutator } from 'satcheljs';

export default mutator(markSearchFolderAsPopulated, actionMessage => {
    const { favoriteId } = actionMessage;

    const personaData =
        favoriteStore.outlookFavoritePersonas.get(favoriteId) ||
        favoriteStore.outlookFavoritePrivateDistributionLists.get(favoriteId);

    // personaNode can be undefined if user removed favorite before the search folder has been populated
    if (personaData) {
        personaData.isSearchFolderPopulated = true;
    }
});
